export const HalcyonAddFormsFormTestIds = {
  FORMS_SELECT: 'halcyon-add-forms-form.forms-select',
  YEAR_MODE_SELECT: 'halcyon-add-forms-form.year-mode-select',
  SPECIFIC_YEARS_SELECT: 'halcyon-add-forms-form.specific-years-select',
};
